<section class="services-section">
  <div class="container">
    <h2 class="services-title">Servicios</h2>

    <div class="carousel-container">
      <!-- 👇 Sin .nativeElement, solo el nombre de la referencia -->
      <button class="carousel-arrow left" (click)="scroll('left')" aria-label="Anterior">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>

      <div #carouselTrack class="carousel-wrapper">
        @for (service of extendedServices; track $index) {
        <!-- 👇 [routerLink] para redirección + cursor pointer -->
        <div class="service-card" [routerLink]="service.route" style="cursor: pointer;">
          <div class="card-image">
            <img [src]="service.img" [alt]="service.alt">
          </div>
          <div class="card-content">
            <h3>{{ service.title }}</h3>
          </div>
        </div>
        }
      </div>

      <!-- 👇 Sin .nativeElement -->
      <button class="carousel-arrow right" (click)="scroll('right')" aria-label="Siguiente">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
  </div>
</section>